module.exports = __webpack_public_path__ + "img/Bender-sample.08ce3d7e.gif";